// src/utils/costingUtils.js — pure costing helpers and constants

export const MARGINS   = [10, 15, 20, 25, 30, 40];
export const SAMPLE_KG = 1;

export const PKG_COLS = [
  { hdrBg:"#f0f7ff", hdrColor:"#1e40af", colBg:"#f8fbff", custBg:"#eef3ff", custColor:"#1e40af" },
  { hdrBg:"#f0fdf4", hdrColor:"#166534", colBg:"#f8fff9", custBg:"#e8f8ee", custColor:"#166534" },
  { hdrBg:"#fffbeb", hdrColor:"#92400e", colBg:"#fffdf5", custBg:"#fff8e8", custColor:"#92400e" },
];

export const fmt2 = n => Number(n).toFixed(2);
export const fmt4 = n => Number(n).toFixed(4);
export const spKg = (perKg, pct) => perKg / (1 - pct / 100);

export function normFormula(f) {
  const qty = Number(f.quantity ?? f.proportion ?? f.qty ?? 0);
  return { ...f, rmId: f.componentId, componentId: f.componentId, type: f.componentType ?? f.type, proportion: qty, qty };
}

export function groupFormulas(list) {
  const map = {};
  for (const f of list) {
    const key = f.parentId ?? f.id;
    if (!map[key]) map[key] = [];
    map[key].push(normFormula(f));
  }
  return map;
}

export function sfgCostPerKg(sfgId, sfgFormulas, rms) {
  return (sfgFormulas[sfgId] || []).reduce((s, f) =>
    s + (rms.find(r => r.id === f.componentId)?.price || 0) * f.proportion, 0);
}

export function fgContentCostPerKg(fgId, fgFormulas, sfgFormulas, rms) {
  return (fgFormulas[fgId] || []).reduce((s, f) => {
    const isSFG = f.type === "SFG";
    const cost  = isSFG ? sfgCostPerKg(f.componentId, sfgFormulas, rms) : (rms.find(r => r.id === f.componentId)?.price || 0);
    return s + cost * f.proportion;
  }, 0);
}

export function packCostBreakdown(fg, pkg, fgFormulas, sfgFormulas, rms, labourPerKg, wastageGlobal) {
  const cc          = fgContentCostPerKg(fg.id, fgFormulas, sfgFormulas, rms);
  const contentCost = cc * pkg.size;
  const labourCost  = labourPerKg * pkg.size;
  const prodCost    = contentCost + labourCost;
  const container   = pkg.price;
  const subtotal    = prodCost + container;
  const wastage     = subtotal * (wastageGlobal / 100);
  const sample      = cc * SAMPLE_KG;
  const packTotal   = subtotal + wastage + sample;
  const perKg       = packTotal / pkg.size;
  return { cc, contentCost, labourCost, prodCost, container, subtotal, wastage, sample, packTotal, perKg };
}

export function sfgPackBreakdown(sfgId, pkg, sfgFormulas, rms, labourPerKg, wastageGlobal) {
  const cc          = sfgCostPerKg(sfgId, sfgFormulas, rms);
  const contentCost = cc * pkg.size;
  const labourCost  = labourPerKg * pkg.size;
  const prodCost    = contentCost + labourCost;
  const container   = pkg.price;
  const subtotal    = prodCost + container;
  const wastage     = subtotal * (wastageGlobal / 100);
  const sample      = cc * SAMPLE_KG;
  const packTotal   = subtotal + wastage + sample;
  const perKg       = packTotal / pkg.size;
  return { cc, contentCost, labourCost, prodCost, container, subtotal, wastage, sample, packTotal, perKg };
}
